<template>
  <b-card no-header>
    <div class="mb-3">
      <h5 class="mb-0">Antrean Review</h5>
    </div>
    <b-row class="filter-row mb-3">
      <b-col cols="12" md="4">
        <b-form-select v-model="filterType" :options="typeOptions" @change="load" />
      </b-col>
      <b-col cols="12" md="4">
        <b-form-select v-model="filterStatus" :options="statusOptions" @change="load" />
      </b-col>
    </b-row>

    <div v-if="isLoading" class="text-center text-muted py-4">Memuat…</div>
    <div v-else-if="!rows.length" class="text-center text-muted py-4">
      Tidak ada data review yang sesuai filter.
    </div>

    <div v-else class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Jenis</th>
            <th>Pengajuan</th>
            <th>Status</th>
            <th>Data</th>
            <th>Diajukan Oleh</th>
            <th>Waktu</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in rows" :key="row.kind + row.id">
            <td>{{ typeLabel(row.target_type) }}</td>
            <td><b-badge :variant="actionVariant(row.action)">{{ actionLabel(row.action) }}</b-badge></td>
            <td><b-badge :variant="statusVariant(row.status)">{{ statusLabel(row.status) }}</b-badge></td>
            <td>
              <router-link :to="targetLink(row)">{{ row.label }}</router-link>
              <div v-if="row.request_note" class="text-muted" style="font-size: 80%;">{{ row.request_note }}</div>
            </td>
            <td>{{ row.requested_by || '-' }}</td>
            <td>{{ row.requested_at }}</td>
            <td class="text-right">
              <b-button v-if="(row.kind === 'request' || row.target_type === 'buy_back') && row.status === 'on_review'" size="sm" variant="secondary" @click="openDetail(row)">Tinjau</b-button>
              <b-button v-else size="sm" variant="secondary" :to="targetLink(row)">Buka</b-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <b-modal ref="detailModal" title="Tinjau Pengajuan" size="lg" hide-footer>
      <template v-if="selected">
        <p>
          <strong>{{ typeLabel(selected.target_type) }}</strong> —
          {{ actionLabel(selected.action) }} atas
          <router-link :to="targetLink(selected)">{{ selected.label }}</router-link>
        </p>
        <p class="text-muted">
          Diajukan oleh {{ selected.requested_by || '-' }} pada {{ selected.requested_at }}.
          <span v-if="selected.request_note"><br>Catatan staff: {{ selected.request_note }}</span>
        </p>

        <div v-if="selected.action === 'update'" class="table-responsive mb-3">
          <table class="table table-sm">
            <thead><tr><th>Field</th><th>Nilai Lama</th><th>Usulan Baru</th></tr></thead>
            <tbody>
              <tr v-for="field in changedFields" :key="field">
                <td>{{ field }}</td>
                <td>{{ displayOld(field) }}</td>
                <td><strong>{{ selected.proposed_snapshot[field] }}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
        <b-alert v-if="selected.action === 'final_data'" show variant="info">
          Jika disetujui, data akhir Tempahan dibuat menjadi stok aktif dan barcode dapat diajukan per barang.
        </b-alert>
        <b-alert v-if="selected.action === 'reopen'" show variant="warning">
          Jika disetujui, stok transaksi ini dikembalikan dan transaksinya menjadi draft
          agar dapat diperbaiki. Nomor transaksi tidak berubah.
        </b-alert>
        <b-alert v-if="selected.action === 'delete'" show variant="danger">
          Jika disetujui, data ini dihapus. Untuk penjualan, stoknya dikembalikan lewat mutasi tercatat.
        </b-alert>

        <label class="form-label mb-1">Catatan Anda</label>
        <b-form-textarea v-model="reviewNote" placeholder="Wajib diisi bila mengembalikan atau menolak" />

        <div class="mt-3">
          <b-button variant="success" :disabled="isLoading" @click="decide('approve')">Setujui</b-button>
          <b-button variant="warning" class="ml-2" :disabled="isLoading" @click="decide('return')">Kembalikan</b-button>
          <b-button variant="danger" class="ml-2" :disabled="isLoading" @click="decide('reject')">Tolak</b-button>
        </div>
      </template>
    </b-modal>
  </b-card>
</template>

<script>
import axios from 'axios'
import ApprovalRequest from '@/models/ApprovalRequest.js'
import BuyBack from '@/models/BuyBack.js'

const approvalRequestModel = new ApprovalRequest()
const buyBackModel = new BuyBack()

export default {
  data () {
    return {
      isLoading: false,
      rows: [],
      selected: null,
      reviewNote: '',
      filterType: null,
      filterStatus: 'on_review',
      typeOptions: [
        { value: null, text: 'Semua jenis' },
        { value: 'stock', text: 'Stok' },
        { value: 'stock_in', text: 'Stok Masuk' },
        { value: 'sale', text: 'Penjualan' },
        { value: 'craft', text: 'Tempahan' },
        { value: 'buy_back', text: 'Buy Back' }
      ],
      statusOptions: [
        { value: 'on_review', text: 'On Review' },
        { value: 'approved', text: 'Disetujui' },
        { value: 'returned', text: 'Dikembalikan' },
        { value: 'rejected', text: 'Ditolak' },
        { value: 'all', text: 'Semua Status' }
      ]
    }
  },
  computed: {
    changedFields () {
      return this.selected && this.selected.proposed_snapshot
        ? Object.keys(this.selected.proposed_snapshot)
        : []
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    typeLabel (type) {
      return { stock: 'Stok', stock_in: 'Stok Masuk', sale: 'Penjualan', craft: 'Tempahan', buy_back: 'Buy Back' }[type] || type
    },
    actionLabel (action) {
      return { create: 'Data baru', final_data: 'Data akhir Tempahan', update: 'Perubahan', reopen: 'Perubahan', delete: 'Hapus', print_barcode: 'Cetak Barcode' }[action] || action
    },
    actionVariant (action) {
      return { create: 'primary', final_data: 'info', update: 'warning', reopen: 'warning', delete: 'danger', print_barcode: 'info' }[action] || 'secondary'
    },
    statusLabel (status) {
      return { on_review: 'On Review', approved: 'Disetujui', returned: 'Dikembalikan', rejected: 'Ditolak' }[status] || status
    },
    statusVariant (status) {
      return { on_review: 'warning', approved: 'success', returned: 'warning', rejected: 'danger' }[status] || 'secondary'
    },
    targetLink (row) {
      const base = { stock: '/stocks/', stock_in: '/stock-ins/', sale: '/sales/', craft: '/crafts/', buy_back: '/buy-backs/' }[row.target_type]
      return base + row.target_id
    },
    displayOld (field) {
      const snapshot = this.selected.current_snapshot || {}
      const value = snapshot[field]
      return value === null || value === undefined || value === '' ? '-' : value
    },
    async load () {
      this.isLoading = true
      try {
        const params = { status: this.filterStatus }
        if (this.filterType) params.type = this.filterType
        const resp = await axios.get(process.env.VUE_APP_API_URL + 'reviews', { params })
        this.rows = resp.data.data
      } catch (e) {
        this.$store.dispatch('notification/error', e)
      }
      this.isLoading = false
    },
    openDetail (row) {
      this.selected = row
      this.reviewNote = ''
      this.$refs.detailModal.show()
    },
    async decide (decision) {
      if (decision !== 'approve' && !this.reviewNote) {
        this.$store.dispatch('notification/error', 'Catatan alasan wajib diisi.')
        return
      }
      this.isLoading = true
      try {
        const id = this.selected.id
        if (this.selected.target_type === 'buy_back') {
          if (decision === 'approve') {
            await buyBackModel.approve(id)
          } else if (decision === 'return') {
            await buyBackModel.returnForRevision(id, this.reviewNote)
          } else {
            await buyBackModel.reject(id, this.reviewNote)
          }
        } else if (decision === 'approve') {
          await approvalRequestModel.approve(id, this.reviewNote)
        } else if (decision === 'return') {
          await approvalRequestModel.returnForRevision(id, this.reviewNote)
        } else {
          await approvalRequestModel.reject(id, this.reviewNote)
        }
        this.$store.dispatch('notification/success', 'Keputusan tersimpan.')
        this.$refs.detailModal.hide()
        await this.load()
      } catch (e) {
        this.$store.dispatch('notification/error', e)
      }
      this.isLoading = false
    }
  }
}
</script>
